<template>
    <DModal
        :show="showModal"
        :title="__('administrations.cron_jobs.modals.cron_job_error_details.title')"
        is-big
        @update:show="$emit('update:showModal', $event)"
        @close="closeModal()"
    >
        <DCard>
            <DCardBody>
                <DTable
                    :items="jobErrors"
                    :fields="fields"
                />
            </DCardBody>
        </DCard>
        <template #actions>
            <DButton
                v-if="userPermissions.includes('admin.cronjobs')"
                :label="__('administrations.cron_jobs.go_to_the_cron_job_settings_page')"
                @click="$inertia.get(cronJobSettingLink()), closeModal()"
            />
        </template>
    </DModal>
</template>

<script>
export default {
    name: 'CronJobMonitoringDetailsModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        cronJobErrors: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            fields: [
                { key: 'job', label: this.__('administrations.cron_jobs.table.job') },
                { key: 'error', label: this.__('administrations.cron_jobs.table.error') },
                { key: 'last_execution', label: this.__('administrations.cron_jobs.table.last_execution') }
            ]
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        },
        jobErrors () {
            return this.cronJobErrors.map(jobError => {
                return {
                    job: jobError.job,
                    error: jobError.summary === null
                        ? this.__('administrations.cron_jobs.messages.manually_disabled')
                        : this.__('administrations.cron_jobs.messages.' + jobError.job + '.' + jobError.summary),
                    last_execution: jobError.last_execution
                }
            })
        }
    },
    methods: {
        cronJobSettingLink () {
            return this.$route('administrations.cron-jobs.index')
        },
        closeModal () {
            this.$emit('close-modal')
        }
    }
}
</script>

<style scoped>

</style>
